<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印电抗铭牌"
      class="materialCodeModal"
      width="700px"
      top="5vh">
    <!--    60*30-->
    <div id="labelSettings">
      <el-form :inline="true" label-width="90px">
        <el-form-item label="表头">
          <el-input v-model="titleName"/>
        </el-form-item>
        <el-form-item label="LOGO">
          <el-checkbox v-model="logoVisible"/>
        </el-form-item>
        <el-form-item label="规格型号">
          <el-input v-model="printType"/>
        </el-form-item>
        <el-form-item label="DATE">
          <el-input v-model="printDate"/>
        </el-form-item>
        <el-form-item label="P(In)">
          <el-input v-model="printL1"/>
        </el-form-item>
        <el-form-item label="∆U(L)">
          <el-input v-model="printL2"/>
        </el-form-item>
        <el-form-item label="AC">
          <el-input v-model="printAC"/>
        </el-form-item>
        <el-form-item label="Hz">
          <el-input v-model="printHz"/>
        </el-form-item>
        <el-form-item label="Class">
          <el-input v-model="printClass"/>
        </el-form-item>
        <el-form-item label="条码">
          <el-input v-model="barCodeText" @input="codeChange"/>
        </el-form-item>

      </el-form>
    </div>
    <el-divider/>
    <div id="printMaterialBoxLabel6">
      <img style="width: 20px;height: 100px;" v-if="logoVisible" :src="logoSrc">
      <div style="flex: 1;margin: 2px 5px 0px 5px;text-align: center;">
        <div style="font-size: 14px;font-weight: bold;">{{titleName}}</div>
        <div style="font-size: 12px;font-family: 'Arial Narrow';font-weight: bold;letter-spacing: -0.5px;">{{printType}}</div>
        <div style="display: flex;text-align: center">
          <div style="font-size: 11px;font-weight: bold;">{{printPIn}}{{printL1}}</div>
          <div style="font-size: 11px;margin-left: 80px;font-weight: bold;">{{printUL}}{{printL2}}</div>
        </div>
        <div style="display: flex;">
          <div style="font-size: 11px;font-weight: bold;">{{printAC}}</div>
          <div style="font-size: 11px;margin-left: 10px;font-weight: bold;">{{printHz}}</div>
          <div style="font-size: 11px;margin-left: 15px;font-weight: bold;">{{printClass}}</div>
        </div>
        <img style="width:100%;height:20px;" :id="(() => 'barCode6_'+productInfo.pkid)()">
        <div style="font-size: 11px;font-weight: bold;margin-top: -6px;">{{barCodeText}}</div>
      </div>
      <!--      <div style="width: 5px;height: 60px;">-->
      <!--        <span style="transform: rotate(270deg);font-size: 12px;">Made In China</span>-->
      <!--      </div>-->
      <img style="width: 16px;height: 100px" :src="madeInChinaSrc">
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" v-print="printOption" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import JsBarcode from "jsbarcode";
  import moment from "moment";

  export default {
    data() {
      return {
        dialogVisible: false,
        titleName: "AC Input Reactor",
        logoVisible: true,
        printType: "",
        printDate: "",
        printName: "",
        printL1: "",
        printPIn: "P:",
        printL2: "",
        printUL: "∆U:",
        printAC: "",
        printHz: "",
        printClass: "",
        productInfo: {},
        logoSrc: "",
        madeInChinaSrc: "",
        barCodeText: "",
        printOption: {
          id: "printMaterialBoxLabel6",
          preview: false,
          popTitle: "打印",
          previewPrintBtnLabel: "打印",
          clickMounted() {
          },
        },
      };
    },

    methods: {
      open(productInfo) {
        // this.logoSrc = "../../../../img/se/print_logo.png";
        this.logoSrc = "../../../../img/se/logo_rol.png";
        this.madeInChinaSrc = "../../../../img/se/madeInChina.png";
        this.dialogVisible = true;
        this.productInfo = productInfo;

        this.printType = this.productInfo.specification;
        if (this.printType) {
          let params = this.printType.split("-");
          if (params[0] == "ACR") {
            this.titleName = "AC Input Reactor";
          } else if (params[0] === "OCR") {
            this.titleName = "AC Output Reactor";
          } else if (params[0] === "DCR") {
            this.titleName = "DC Reactor";
          } else if (params[0] === "VTR") {
            this.titleName = "DV/DT Filter";
          } else if (params[0] === "SFR") {
            this.titleName = "Sine Wave Filter";
          }

          if (params.length === 3) {
            if (params[0] == "ACR") {
              this.printPIn = "P:";
              this.printUL = "∆U:";
              this.printL1 = params[1].replace("K", "kw");
              this.printL2 = "2%";
              this.printAC = "AC 380V";
              this.printHz = "50-60Hz";
              this.printClass = "class:F";

            } else if (params[0] == "OCR") {
              this.printPIn = "P:";
              this.printUL = "∆U:";
              this.printL1 = params[1].replace("K", "kw");
              this.printL2 = "1%";
              this.printAC = "AC 380V";
              this.printHz = "50-60Hz";
              this.printClass = "class:F";
            }

          } else if (params.length >= 4) {
            if (params[0] == "ACR" || params[0] == "OCR" || params[0] == "SFR") {
              this.printPIn = "In:";
              this.printUL = "L:";
              this.printL1 = parseInt(params[1]) + "A";
              this.printL2 = parseFloat(params[2].replace("M", ".")) + "mH";
              this.printAC = "AC 380V";
              this.printHz = "50-60Hz";
              this.printClass = "class:F";
            } else if (params[0] == "DCR") {
              this.printPIn = "In:";
              this.printUL = "L:";
              this.printL1 = parseInt(params[1]) + "A";
              this.printL2 = parseFloat(params[2].replace("M", ".")) + "mH";
              this.printAC = "Voltage 380V";
              this.printHz = "50-60Hz";
              this.printClass = "class:F";
            } else if (params[0] == "VTR") {
              this.printPIn = "In:";
              this.printUL = "L:";
              this.printL1 = parseInt(params[1]) + "A";
              this.printL2 = parseFloat(params[2].replace("M", ".")) + "mH";
              this.printAC = "AC 690V";
              this.printHz = "50-60Hz";
              this.printClass = "class:F";
            }

          }
        }

        this.printName = this.productInfo.materialName;
        this.printDate = this.productInfo.planFinishTime;
        // this.barCodeText = moment(new Date()).format("YYYYMMDD");
        this.barCodeText = moment(new Date(this.printDate)).format("YYYYMMDD");

        this.$nextTick(() => {
          document.getElementById("barCode6_" + this.productInfo.pkid).innerHTML = "";
          this.bindBarCode(this.barCodeText, this.productInfo.pkid);
        });
      },
      bindBarCode(row, id) {
        let text = row;
        new JsBarcode(document.getElementById("barCode6_" + id), row, {
          text: text,
          fontSize: 14,
          width: 4,
          height: 8,
          margin: 0,
          displayValue: false,
        });
      },
      codeChange() {
        // this.$nextTick(() => {
        document.getElementById("barCode6_" + this.productInfo.pkid).innerHTML = "";
        this.bindBarCode(this.barCodeText, this.productInfo.pkid);
        // });
      },

      print() {
      },
    },
  };
</script>
<style lang="scss" scoped>
.materialCodeModal .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.materialCodeModal .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.materialCodeModal .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 39px;
  height: 90%;
}

.materialCodeModal .el-divider--horizontal {
  margin: 10px 0;
}

.materialCodeModal .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>

<style lang="scss" scoped>
#printMaterialBoxLabel6 {
  width: 58mm;
  height: 28mm;
  margin: 0 auto;
  //margin-top: 1mm;
  page-break-before: always;
  font-size: 10px;
  display: flex;
  align-items: center;
}
</style>
